import loadable from '@loadable/component';

import { CmsApiPersonaQuizBlockData } from 'modules/cms/api/types/blocks/CmsApiPersonaQuizBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsPersonaQuizBlockMapping: CmsBlockMapping<CmsApiPersonaQuizBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: hydrateOnDemand(
      loadable(() => import('./CmsPersonaQuizBlock'), {
        resolveComponent: (module) => module.CmsPersonaQuizBlock,
      }),
    ),
    AmpComponent: loadable(() => import('./CmsAmpPersonaQuizBlock'), {
      resolveComponent: (module) => module.CmsAmpPersonaQuizBlock,
    }),
  };
